import { gql } from '@apollo/client'

export default gql`
  query GetClinicLocation($name: String) {
    practices(name: $name) {
      id
      name
    }
  }
`
